export default {
  folder: "x70-plus",
  interior: {
    points: [
      [-2000, -400, 0], // Adjustable second-row seats
      [2000, -700, 200], // CN95 filter for smart air purification.
      [2000, -400, 0], // 10.25 inch multimedia screen with Bluetooth
      [1000, -1600, -800], // Ventilated Front Seats
      [1500, 2000, 0], // Panoramic Sunroof.
      [2000, -1600, -200], // Cruise Control
    ],
  },
  exterior: {
    hotspots: {
      h1: {
        popup: 1,
        // 20-inch Alloy Wheels
        point: [
          [57, 69], // f1
          [50, 69], // f2
          [44, 69], // f3
          [38, 68], // f4
          [33, 67], // f5
          [28, 65], // f6
          [24, 64], // f7
          [22, 63], // f8
          [21, 61], // f9
          [62, 70], // f10
          [57, 73], // f11
          [52, 74], // f12
          [46, 75], // f13
          null, // f14
          null, // f15
          null, // f16
          null, // f17
          [57, 75], // f18
          [52, 76], // f19
          [47, 75], // f20
          [41, 74], // f21
          [36, 72], // f22
          [32, 70], // f23
          [28, 68], // f24
          [24, 67], // f25
          [22, 65], // f26
          [70, 68], // f27
          [64, 69], // f28
          [58, 69], // f29
          [51, 69], // f30
          [45, 70], // f31
          [38, 69], // f32
          null, // f33
          null, // f34
          null, // f35
          [62, 69], // f36
        ],
      },
      h2: {
        popup: 2,
        // LED Head Light and Fog Light
        point: [
          [47, 45], // f1
          [39, 44], // f2
          [33, 45], // f3
          [25, 46], // f4
          [19, 44], // f5
          [16, 43], // f6
          [14, 42], // f7
          null, // f8
          null, // f9
          null, // f10
          null, // f11
          null, // f12
          null, // f13
          null, // f14
          null, // f15
          null, // f16
          null, // f17
          null, // f18
          null, // f19
          null, // f20
          null, // f21
          null, // f22
          [85, 40], // f23
          [88, 41], // f24
          [88, 42], // f25
          [87, 43], // f26
          [84, 45], // f27
          [79, 45], // f28
          [73, 48], // f29
          [63, 46], // f30
          [55, 47], // f31
          [46, 45], // f32
          [38, 46], // f33
          [31, 45], // f34
          [62, 45], // f35
          [54, 45], // f36
        ],
      },
      h3: {
        popup: 3,
        // 5 high-definition camera in the whole vehicle, 360 all-round protections
        point: [
          [68, 29], // f1
          [64, 31], // f2
          [59, 31], // f3
          [54, 31], // f4
          [49, 32], // f5
          [44, 31], // f6
          [39, 32], // f7
          [34, 32], // f8
          [32, 32], // f9
          [30, 33], // f10
          [30, 33], // f11
          [30, 33], // f12
          [30, 33], // f13
          [31, 31], // f14
          [32, 31], // f15
          [65, 29], // f16
          [67, 30], // f17
          [68, 31], // f18
          [69, 32], // f19
          [70, 33], // f20
          [70, 33], // f21
          [69, 33], // f22
          [68, 33], // f23
          [65, 32], // f24
          [63, 32], // f25
          [59, 32], // f26
          [54, 32], // f27
          [48, 31], // f28
          [42, 31], // f29
          [38, 31], // f30
          [34, 30], // f31
          [30, 29], // f32
          [29, 29], // f33
          [69, 28], // f34
          [70, 28], // f35
          [69, 28], // f36
        ],
      },
      h4: {
        popup: 4,
        // LED Meteor Tail Lights
        point: [
          null, // f1
          null, // f2
          null, // f3
          null, // f4
          null, // f5
          null, // f6
          null, // f7
          null, // f8
          [86, 37], // f9
          [82, 39], // f10
          [77, 42], // f11
          [71, 45], // f12
          [63, 48], // f13
          [55, 51], // f14
          [48, 52], // f15
          [59, 52], // f16
          [51, 52], // f17
          [43, 51], // f18
          [35, 48], // f19
          [28, 45], // f20
          [21, 42], // f21
          [17, 39], // f22
          [13, 37], // f23
          null, // f24
          null, // f25
          null, // f26
          null, // f27
          null, // f28
          null, // f29
          null, // f30
          null, // f31
          null, // f32
          null, // f33
          null, // f34
          null, // f35
          null, // f36
        ],
      },
      h5: {
        popup: 5,
        // 1.6TGDI+7DCT golden power combination
        point: [
          [35, 38], // f1
          [30, 37], // f2
          [27, 37], // f3
          [24, 36], // f4
          [28, 37], // f5
          [26, 38], // f6
          [24, 38], // f7
          [24, 38], // f8
          [23, 37], // f9
          [22, 37], // f10
          [23, 37], // f11
          null, // f12
          null, // f13
          null, // f14
          null, // f15
          null, // f16
          null, // f17
          null, // f18
          null, // f19
          null, // f20
          null, // f21
          [76, 37], // f22
          [76, 37], // f23
          [76, 37], // f24
          [77, 37], // f25
          [76, 37], // f26
          [76, 37], // f27
          [71, 36], // f28
          [70, 36], // f29
          [68, 37], // f30
          [66, 37], // f31
          [60, 37], // f32
          [55, 38], // f33
          [49, 37], // f34
          [43, 37], // f35
          [39, 36], // f36
        ],
      },
    },
  },
};
